<template>
  <div id="aboutAndJoinUs">
    <!--banner区域-->
    <div class="bannerWrap">
      <div class="contentWrap">
        <div class="content">
          <div class="contentTitle">摩卡星用户隐私保护政策</div>
          <div class="contentVal">
            <span>探索和耕耘企业级⼤数据服务领域</span>
            <span>构建以数据为基础的⽣态，不断为合作伙伴创造价值</span>
          </div>
        </div>
      </div>
    </div>
    <!--内容区-->
    <privacy></privacy>
  </div>
</template>
<script>
import privacy from "@/views/aboutAndJoinUs/components/privacyDetails";
export default {
  components: {
    privacy
  }
};
</script>
<style lang="scss" scoped>
#aboutAndJoinUs {
  .bannerWrap {
    background: url("../../assets/img/privacyPolicy/bg.png") no-repeat center;
    background-color: #00051d;
    height: 298px;
    .content {
      margin-top: 12px;
    }
  }
}
</style>
